import React from 'react'
import style from '../../../css/homepage/Conditions.module.css'


const Refundpolicy = () => {
    return (
        <div>
            <div className={`${style.containerfluid} container-fluid`}>
                <div className="container">
                    <div className={`${style.firstrow} row`}>
                        <h2>
                            Refund and Cancellation Policy
                        </h2>
                    </div>

                    <div className={`${style.secondrow} row`}>
                        <h6>
                            Thank you for choosing <a href="">Swingalgo.com</a>. We strive to provide the best services to our clients. However, please read the following Refund and Cancellation Policy carefully before making any purchase.
                        </h6>

                        <h6>
                            All subscriptions and services offered by Swingalgo.com are non-refundable.
                        </h6>

                        <h6>
                            Once a service is subscribed to and paid for, it cannot be canceled or refunded under any circumstances.
                        </h6>

                        <h6>
                            We do not guarantee any specific financial returns on our trade calls or analysis. All services are subject to market risk, and we do not take responsibility for individual client performance.
                        </h6>

                        <h6>
                            While refunds are not possible, we are committed to continuously improving our services to enhance customer satisfaction.
                        </h6>

                        <h6>
                            Before making any payment, please ensure that you have read and understood our Terms and Conditions, Disclaimers, Disclosures, and this Refund Policy.
                        </h6>

                        <h6>
                            By making a payment, you acknowledge and agree to this No Refund Policy.
                        </h6>

                        <h6>
                            For any inquiries, please contact us at <a href="">support@Swingalgo.com</a>.
                        </h6>
                    </div>

                    <div className={`${style.thirdrow} row`}>
                        <h5>
                            Last Updated: <span className={style.updatedate}>May 1, 2025</span>
                        </h5>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Refundpolicy